import store from "@utils/store/cookie";
import { getUserInfo } from "@api/user";
import dialog from "@utils/dialog";

const LOGIN_KEY = "login_status";

const state = {
  footer: true,
  home: true,
  homeActive: false,
  token: store.get(LOGIN_KEY) || null,
  backgroundColor: "#fff",
  shop: {},
  userInfo: null,
};

const mutations = {
  SHOW_FOOTER(state) {
    state.footer = true;
  },
  HIDE_FOOTER(state) {
    state.footer = false;
  },
  SHOW_HOME(state) {
    state.home = true;
  },
  HIDE_HOME(state) {
    state.home = false;
  },
  OPEN_HOME(state) {
    state.homeActive = true;
  },
  CLOSE_HOME(state) {
    state.homeActive = false;
  },
  LOGIN(state, { token, expire }) {
    state.token = token;
    console.info(token, expire);
    store.set(LOGIN_KEY, token, expire);
  },
  LOGOUT(state) {
    state.token = undefined;
    store.remove(LOGIN_KEY);
  },
  BACKGROUND_COLOR(state, color) {
    state.color = color;
    document.body.style.backgroundColor = color;
  },
  SET_SHOP: (state, shop) => {
    state.shop = shop;
  },
  UPDATE_USERINFO(state, userInfo) {
    state.userInfo = userInfo;
  },
};

const actions = {
  USERINFO({ state, commit }, force) {
    if (state.userInfo !== null && !force) {
      return Promise.resolve(state.userInfo);
    } else {
      return new Promise((reslove) => {
        getUserInfo().then((res) => {
          console.info(res);
          commit("UPDATE_USERINFO", res.result);
          commit("SET_SHOP", {
            id: res.result.shopId,
            name: res.result.shopName,
          });
          reslove(res.result);
        });
      }).catch(() => {
        dialog.error("获取信息失败!");
      });
    }
  },
};

export default {
  state,
  mutations,
  actions,
};
